import { useEffect, useState } from 'react';
import { Icon, gift } from '../../../components/Icon/Icon';
import { useConfig } from '../../../config';
import { useFormatting, useTranslation } from '../../../i18n/i18n';
import { Res, useApi } from '../../../state/api';
import { ContentCard } from '../../ContentCard/ContentCard';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { useQuery } from '../../Routes';
import './BonusWallet.css';

export const BonusWallet = ({ heading = '' }: { heading?: string }): JSX.Element => {
	const t = useTranslation().bonusPage;
	const { defaultVat, currencyCode } = useConfig();
	const { data: bonusBalance, isLoading, error } = useApi(Res.bonusBalance, {});
	const [count, setCount] = useState(0);
	const [animationComplete, setAnimationComplete] = useState(false);
	const [balance, setBalance] = useState(0);
	const { activated } = useQuery<{ activated: string }>();
	const { asPrice } = useFormatting();

	useEffect(() => {
		let start = 0;
		if (bonusBalance) {
			const end = bonusBalance.bonusAmount;
			setBalance(end);

			if (isLoading || start === end || end === undefined) return;

			let totalMilSecDur = 2;
			let incrementTime = (totalMilSecDur / end) * 100;
			let timer = setInterval(() => {
				start += 1;
				setCount(start);
				if (start >= end) {
					clearInterval(timer);
					setAnimationComplete(true);
				}
			}, incrementTime);
		}
	}, [bonusBalance, isLoading]);

	if (error && !bonusBalance) return <ErrorMessage />;

	let bonusContent: JSX.Element;
	if (activated) {
		bonusContent = <h2 className="activated">{t.youAreBonusCustomer}</h2>;
	} else {
		if (!bonusBalance) {
			bonusContent = <h2>{heading != '' ? heading : t.currentBalance}</h2>;
		} else {
			const balanceVat = (defaultVat / 100) * balance + balance;

			bonusContent = (
				<>
					<h2>{heading != '' ? heading : t.currentBalance}</h2>
					<p className="current-bonus-text">
						{asPrice(
							currencyCode === 'EUR' && animationComplete ? balance : count,
							2,
							currencyCode !== 'EUR'
						)}
					</p>
					<p className="inc-vat-text">
						<strong>
							{asPrice(
								currencyCode === 'EUR' && animationComplete ? balanceVat : Math.round(balanceVat),
								2,
								currencyCode !== 'EUR'
							)}
						</strong>{' '}
						{t.incVat} ({defaultVat}%)
					</p>
				</>
			);
		}
	}

	return (
		<ContentCard className="bonus-wallet">
			<div>
				{bonusContent}
				{bonusBalance === undefined && <img src="/images/loader.svg" width="100" alt="loader" />}
				{bonusBalance !== undefined && <Icon shape={gift} size={120} />}
			</div>
		</ContentCard>
	);
};
